var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-vg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -3.68 -.673)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -3.676 -.451)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -4.457 -.249)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -3.694 -.033)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -3.696 .18)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -3.7 .395)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -4.463 .391)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -4.456 .18)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -4.446 -.036)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -4.455 -.462)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.65977 0 0 1.4919 -3.833 -.263)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 92.551,
    gradientTransform: "matrix(.85004 0 0 1.9222 723.32 109.68)",
    y1: 111.28,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h1024v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#006",
    d: "M0 0h512v256H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v28.622L454.757 256h57.241v-28.62L57.241 0H0zm511.998 0v28.62L57.241 256H0v-28.62L454.757 0h57.241z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.333 0v255.999h85.333V0h-85.333zM0 85.333v85.333h511.998V85.333H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 102.4v51.2h511.998v-51.2H0zM230.4 0v255.999h51.199V0h-51.2zM0 255.999l170.666-85.333h38.16L38.162 255.999H0zM0 0l170.666 85.333h-38.16L0 19.081V0zm303.171 85.333L473.837 0h38.161L341.332 85.333h-38.16zm208.827 170.666l-170.666-85.333h38.16l132.506 66.253v19.08z",
    fill: "#c00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.39 193.617l213.68-.793-.396 190.29s7.532 28.94-89.593 72.943c34.886-3.568 72.943-40.832 72.943-40.832s15.46-19.82 22.993-8.721c7.532 11.1 14.668 16.65 20.218 21.01 5.55 4.361 9.91 16.255 1.585 24.976s-21.407 9.91-24.975-.793c-5.55 2.775-39.643 44.004-109.41 45.986-70.96-1.19-109.81-46.382-109.81-46.382s-9.514 15.064-22.993 3.171c-13.082-15.46-3.171-25.372-3.171-25.372s11.1-6.342 14.27-10.704c5.154-5.946 6.74-13.875 15.462-13.875 10.307.793 14.27 9.118 14.27 9.118s35.68 37.661 74.133 42.418c-86.818-41.625-89.99-67.393-89.593-73.736l.396-188.7z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.54 198.767l203.76-1.19v183.15c.396 23.787-39.643 47.969-102.28 78.89-64.61-33.3-101.87-53.52-102.27-79.28l.793-181.56z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.718,
    fill: "#006129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.042 400.578l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.486 393.966a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.303 413.63l18.647.052s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H276.34s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.646 409.841l15.532-.053m-22.645-9.108s1.242 7.265 6.977 8.985",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#c)",
    transform: "translate(196.13 180.867) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.294 383.358a2.197 2.197 0 1 1-4.395.002 2.197 2.197 0 0 1 4.395-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.362 364.219l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.806 357.607a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.623 377.27l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H275.66s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.966 373.482l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#d)",
    transform: "translate(195.45 144.508) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.614 347a2.197 2.197 0 1 1-4.395 0 2.197 2.197 0 0 1 4.395 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.142 331.167l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.586 324.555a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.403 344.218l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H403.44s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.746 340.43l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#e)",
    transform: "translate(323.23 111.456) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.394 313.947a2.197 2.197 0 1 1-4.395.002 2.197 2.197 0 0 1 4.395-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.342 295.823l12.028-17.665 12.086 17.703",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.786 289.212a2.389 2.389 0 1 1-4.777.001 2.389 2.389 0 0 1 4.777-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.603 308.875l18.647.053s.293-2.42-1.947-3.891c9.766-1.343 7.23-9.958 15.409-10.446 1.587.244-4.273 3.662-4.273 3.662s-4.932 3.48-2.686 5.25c1.783 1.405 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.029-12.575 2.686-12.575 2.686l-7.665-.043c-.477-.86-2.59-4.31-4.771-4.326-2.588.095-4.411 4.369-4.411 4.369H278.64s-.595 4.448 8.195 5.302c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.663z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.946 305.087l15.532-.053m-22.645-9.108s1.242 7.264 6.977 8.985",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#f)",
    transform: "translate(198.43 76.112) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.594 278.604a2.197 2.197 0 1 1-4.395.001 2.197 2.197 0 0 1 4.395-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.612 261.085l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.056 254.473a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.873 274.136l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H278.91s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.216 270.348l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#g)",
    transform: "translate(198.7 41.374) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.864 243.865a2.197 2.197 0 1 1-4.395.002 2.197 2.197 0 0 1 4.395-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.272 225.839l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.716 219.227a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.533 238.89l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H279.57s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.876 235.102l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#h)",
    transform: "translate(199.36 6.128) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.524 208.62a2.197 2.197 0 1 1-4.395 0 2.197 2.197 0 0 1 4.395 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.092 226.413l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.536 219.801a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.353 239.464l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H404.39s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.696 235.676l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#i)",
    transform: "translate(324.18 6.702) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.344 209.193a2.197 2.197 0 1 1-4.395.002 2.197 2.197 0 0 1 4.395-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.952 261.012l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.396 254.4a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.213 274.063l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H403.25s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.556 270.275l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#j)",
    transform: "translate(323.04 41.301) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.204 243.792a2.197 2.197 0 1 1-4.395.002 2.197 2.197 0 0 1 4.395-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.422 296.376l12.028-17.665 12.086 17.703",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.866 289.765a2.389 2.389 0 1 1-4.777.001 2.389 2.389 0 0 1 4.777-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.683 309.428l18.647.053s.293-2.42-1.947-3.891c9.766-1.343 7.23-9.958 15.409-10.446 1.587.244-4.273 3.662-4.273 3.662s-4.932 3.48-2.686 5.25c1.783 1.405 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.029-12.575 2.686-12.575 2.686l-7.665-.043c-.477-.86-2.59-4.31-4.771-4.326-2.588.095-4.411 4.369-4.411 4.369H401.72s-.595 4.448 8.195 5.302c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.663z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.026 305.64l15.532-.053m-22.645-9.107s1.242 7.263 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#k)",
    transform: "translate(321.51 76.665) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.674 279.157a2.197 2.197 0 1 1-4.395.001 2.197 2.197 0 0 1 4.395-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.95 400.937l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.288,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.39 394.337a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21 413.987l18.647.053s.292-2.42-1.948-3.89c9.767-1.344 7.23-9.959 15.41-10.447 1.586.244-4.274 3.663-4.274 3.663s-4.931 3.48-2.685 5.25c1.783 1.404 2.563-.855 2.808-2.564.244-1.71 7.935-2.808 6.836-7.692-1.831-4.028-12.575 2.686-12.575 2.686l-7.665-.042c-.478-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368h-17.337s-.594 4.448 8.196 5.303c1.979 2.584 3.513 3.307 5.234 3.976-1.147.955-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55 410.197l15.531-.053m-22.641-9.097s1.243 7.264 6.977 8.985",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 330.27c.573-2.772 1.625-3.25 2.772-6.786.191-3.44-2.772-3.059-1.912-5.257 1.53-2.39.765-4.683-2.103-6.5.574 3.155-3.727 6.118-3.727 8.698 0 2.581 2.198 2.008 1.911 5.926.192 2.294-.573 1.72-.764 3.92h3.823z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "url(#l)",
    transform: "translate(-406.02 70.677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2 383.727a2.197 2.197 0 1 1-4.395.001 2.197 2.197 0 0 1 4.395-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M412.762 365.957l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.206 359.345a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.023 379.008l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H403.06s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.366 375.22l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#m)",
    transform: "translate(322.85 146.246) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.014 348.737a2.197 2.197 0 1 1-4.395.002 2.197 2.197 0 0 1 4.395-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.142 333.444l12.028-17.665 12.086 17.702",
    stroke: "#f7c600",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.586 326.832a2.389 2.389 0 1 1-4.777.002 2.389 2.389 0 0 1 4.777-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.403 346.495l18.647.053s.293-2.42-1.947-3.89c9.766-1.343 7.23-9.958 15.409-10.447 1.587.245-4.273 3.663-4.273 3.663s-4.932 3.48-2.686 5.25c1.783 1.404 2.564-.855 2.808-2.564.244-1.71 7.936-2.808 6.837-7.691-1.831-4.03-12.575 2.685-12.575 2.685l-7.665-.042c-.477-.86-2.59-4.31-4.771-4.326-2.588.094-4.411 4.368-4.411 4.368H301.44s-.595 4.448 8.195 5.303c1.98 2.585 3.514 3.307 5.234 3.976-1.147.956-1.47 2.112-1.465 3.662z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.746 342.707l15.532-.053m-22.645-9.107s1.242 7.264 6.977 8.984",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "url(#n)",
    transform: "translate(221.23 113.733) scale(1.2884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.394 316.224a2.197 2.197 0 1 1-4.395.002 2.197 2.197 0 0 1 4.395-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.805,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.501 417.404s4.866 11.219 10.408 4.325 3.514-9.867 3.514-9.867l-12.435-6.759-3.65 7.705 2.163 4.596z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.182 415.922s.81.135 1.487-1.081-1.487-1.758-2.433-3.11l-1.082 2.164 2.028 2.027zm-28.126-2.976l-10.949 5.947s-5.406 1.082-5.812 0c-.405-1.081.135-2.027 2.974-2.162 2.838-.136 10.543-7.164 10.543-7.164l3.244 3.379zm.142-194.51s.27 2.568.405 3.92-2.162 4.19-2.298 4.055-1.216.135-1.08.946 1.756 1.082 1.756 1.082-.676 2.838 0 2.973c.676.135-1.757 3.65 0 4.596 1.757.946 4.731 2.163 6.083 1.892 1.352-.27 0 5.272 0 5.272l-3.785 8.11 20.816-2.163-4.326-6.893s-2.027-1.352-1.487-5.272c.541-3.92-.27-21.627-.27-21.627l-14.868-2.028-.946 5.137zm-3.788 30.819s-6.758 3.109-6.488 11.489c-1.757 8.11-2.704 16.22-2.704 16.22s-7.974 9.056-10.407 12.3c-2.433 3.244-6.083 9.867-7.435 11.624s-6.623 7.57-6.488 9.733c.135 2.162-1.216 11.76 4.055 12.84 1.352.541 5.677-11.083 5.677-11.083s.27-5.001-1.216-5.948 3.244-4.19 3.244-4.19 9.056-6.623 11.084-8.245 7.57-7.84 7.57-7.84l3.108-36.901z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#ffc6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.115 242.902s1.757 4.73 5.677 3.92c3.92-.812 8.515-4.461 8.515-4.461s3.65-.135 4.19.405c.541.54 9.868 9.597 9.597 12.436-.27 2.838-4.325 2.027-5.812 3.92s-3.92 6.623-3.244 10.137 2.704 8.11 2.433 9.868-1.757 2.297-1.757 3.244c0 .946 1.217 2.568 1.217 4.325s-1.622 4.325-1.352 6.083c.27 1.757.405 6.893.405 6.893l-.405 23.79s1.352.811 1.487 2.163c.135 1.352 9.191 40.685 9.191 40.685s-.405 1.217-1.351 1.082 3.65 6.082 3.784 7.84 4.731 15.544 4.596 17.437c-.135 1.892-.811 6.082-1.217 6.217-.405.135 2.974 8.651 2.433 10.003-.54 1.351-6.082 1.216-6.082 1.216l-1.487-.27s.135 1.757-.946 1.892-9.056-.405-9.056-.405-2.298 3.514-3.65 3.379c-1.352-.135-3.109-2.568-3.514-2.163-.406.406 1.216 2.704.81 3.38-.405.675-7.298 2.162-8.65-1.082-1.352-3.244.81-2.433.405-3.109-.405-.676-3.514-2.433-4.46-1.892s2.433 1.352 2.298 2.703c-.135 1.352-2.974 3.38-4.055 3.38s-3.65-5.002-7.435-4.461c-3.784.54-6.217 1.487-6.217 1.487s-4.461 1.892-6.353 1.487c-1.893-.406-2.704-1.893-2.704-2.704 0-.81 1.352-4.325 1.217-5.406s-1.217-2.163-1.217-3.785c0-1.622 3.11-7.164 3.11-7.164l-.136-24.871s-2.839 0-2.974-1.758 4.326-39.333 5.001-41.767c.676-2.433 2.434-11.084 2.434-11.084s-2.028.946-2.163 0 6.082-22.437 6.082-22.437 1.082-10.679 1.082-13.517c0-2.838-.54-6.758-.54-6.758s-5.55-2.35-5.678-5.948c-.508-5.725 5.272-8.921 5.947-10.813l2.704-7.57s2.974-5.136 7.84-5.947z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.092 414.57s-13.111 6.893-15.004 7.434c-1.892.54-3.109-2.298-1.216-2.839 1.892-.54 4.866-.811 4.866-.811s-4.46-3.514-4.326-3.65c.136-.135 6.083-2.297 6.218-2.297s1.893 3.514 3.11 3.244 4.73-2.974 4.73-2.974 1.892 2.163 1.622 1.892z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.567 418.344c1.24 1.6 1.725 4.372 4.563 2.75 2.839-1.622-1.454-4.632-1.454-4.632l-3.109 1.882z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#ffc6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.747 418.074s1.351 1.081 2.568-.135-2.433-3.785-2.433-3.785l-1.757 2.027 1.622 1.893z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#ffc6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.688 248.172s-12.03 7.705-11.76 10.408m14.466-9.056s-2.703 2.974-2.838 2.974m6.484.27s-5.947 4.866-5.001 7.975m-23.112-13.246s-1.757 3.65-1.351 4.866c.405 1.217 3.379 5.813 3.784 8.651.406 2.839 0 4.866 0 4.866m-5.538-11.625s.54 4.325 1.352 5.136c.81.811 2.974 4.461 3.244 5.948m-5.678 6.893s3.514 1.757 6.758-5.001m5.262-4.731c-.134 0-2.567 6.624 1.758 9.057s7.57 2.163 9.462 1.487c1.892-.676 3.92-1.892 3.92-1.892m-17.02-.541s.27 8.921 13.381 17.708m-12.841-9.329s-.134 7.84 5.002 11.355m-7.707-20.545s-3.92 11.624-7.029 12.84m5.805-4.324s-.135 8.38-1.216 11.354m-1.077 2.027s2.703 3.38 5.677 3.11c2.974-.271 4.19-3.786 6.218-3.245 2.027.54 3.92 2.163 8.65 1.757m-6.759 3.514s0 6.893 1.216 7.57.676 7.028.676 7.028m-18.384-17.841s-.135 6.488-.946 8.786c-.81 2.298-2.433 6.218-2.163 9.597m-5.137 3.789c.676-.27 2.974-2.298 2.974-2.298m1.214 1.486s-5.813 24.871-4.19 39.74m5.543-38.529s-2.974 18.654-1.623 22.168m.141-22.709c.135 0 11.354.811 11.354.811m1.621-1.481s3.108 1.622 7.433 1.352m-8.787 7.706s-.54 31.9-1.351 38.929M379.56 331.3s3.514 27.98 5.541 30.548m-12.306-27.031s2.163 24.736 3.38 26.9m-34.056 8.647s4.19-1.352 7.974-5.406c4.326 5.812 10.95.27 10.95.27s10.272 7.029 14.867-.811c7.029 4.596 10.543-.676 10.543-.676s2.569 3.92 4.46 3.514m-11.225 2.71s5.272 24.736 13.111 31.764m-40.283-34.341s.676 20.681 1.892 35.279m-2.833-11.894s-.675 13.516-1.486 14.463m-6.489 1.358s1.487 5.812 8.921.406c7.435-5.407 7.57 2.027 7.84 2.838.27.811 1.487 6.623 4.325 1.757m5.944-7.977s-1.216 12.03 9.463 3.244c10.678-8.786 12.435-.135 12.705 2.568",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.786 217.624s2.973.406 4.595-.54c1.622-.946 3.515-1.352 4.866.54s2.298 1.758 2.298 1.758-2.027 5 0 5.541c2.028.541 2.974.541 3.11 1.217.134.676-1.758 2.163-1.217 2.838.54.676 1.487 1.487 1.622 2.028.135.54-1.217 2.839-.811 3.38.405.54 1.622 2.703 2.433 2.703.81 0 .27 3.379 2.703 2.568s2.298-2.974 2.298-2.974 2.568-.405 3.244-2.703c.676-2.298 2.298-2.839 2.298-2.839s3.244-1.757-1.081-4.46c0-18.924-12.436-16.896-12.436-16.896s-1.487-3.38-3.92-2.974c-2.433.406-2.568 3.244-4.325 2.974-1.757-.27-2.163-1.487-2.298-1.352-.135.135-1.622 2.838-1.622 3.514 0 .676-4.731-.946-4.326 2.569s2.704 3.379 2.569 3.108z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#9c5100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.773 213.029s-.947 5.947 5.406 5.407c-.81 3.244 1.622 4.325 1.622 4.325m4.722 3.649c.135 0 2.838 1.757-.135 3.92m-9.051.811s1.351 1.622 2.838 1.217c1.487-.406 3.92 1.486 3.92 1.486s2.027.676 2.298.27m-17.303 2.164s4.596 1.757 7.57-5.542m-16.086-2.163l2.704.135",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M356.987 231.276h2.433l-2.163.947",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M360.362 223.707c.406 0 1.893-.54 2.163-.135.27.405-1.622.676-2.163.135z",
    strokeWidth: 1.449,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.557 255.822c.136 0 4.461 13.381 5.002 16.76.54 3.38 2.298 16.897 1.622 18.79-.676 1.892-7.57 10.948-8.38 13.245-.812 2.298-5.678 11.084-5.678 11.084s-1.216 8.651-1.757 9.056c-.54.406 1.395 2.53 1.217 3.245-.269.804-3.92 4.595-5.542 4.19-1.622-.406-4.19-2.298-4.326-4.055s.135-7.57 1.352-9.057 7.57-16.49 7.975-17.437c.405-.946 5.812-12.706 5.947-14.733.135-2.027-1.682-6.716-3.593-8.436-4.255-12.521-2.583-20.072 6.161-22.653z",
    fillRule: "evenodd",
    strokeWidth: 0.805,
    fill: "#ffc6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.58 313.816l.212 5.924m-5.762-6.362s3.798 6.352 3.48 9.737",
    strokeWidth: 0.805,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M371.932 326.649s2.84-.299 2.75 4.442c1.814-5.889 5.5-6.029 5.5-6.029",
    strokeWidth: 0.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.23 461.997c57.086-1.586 93.954-42.814 93.557-43.211-.396-.396 7.532-11.496 13.875-9.91 6.343 1.585 15.461 20.217 26.561 24.181 5.55 8.722-1.586 16.65-3.964 18.236-2.379 1.586-13.082 5.947-14.668-.396-1.586-6.343-4.758-5.154-4.758-5.154s-50.743 49.554-109.41 47.572c-60.65.4-110.6-47.57-110.6-47.57l-4.36 4.757s-4.758 5.154-7.136 4.758c-2.379-.397-12.686-7.136-13.48-13.875-.792-6.74 6.344-11.1 6.344-11.1s17.443-13.48 19.425-20.614c3.964-3.965 11.496 2.774 11.496 2.774S311.098 465.17 362.237 462z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.718,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 431.337s4.717-1.258 6.447.708c1.73 1.965 13.6 13.6 13.6 13.6",
    stroke: "#000",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77 436.837l-4.717 3.538s11.87 2.358 9.198 10.142m243.719-19.58s-2.359-1.258-6.054 1.494c-3.695 2.751-13.05 13.208-13.05 13.208",
    stroke: "#000",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.36 436.527l5.11 3.93s-10.692.708-8.333 10.85",
    stroke: "#000",
    strokeWidth: 1.718,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.43 443.917l-.344.482c-.717-.354-1.535-.42-2.453-.197-.675.174-1.945.807-3.812 1.9l-15.708 9.157-.43-.307 3.958-18.363c.478-2.213.696-3.558.655-4.032-.032-.47-.364-.987-.994-1.555l.344-.482 8.467 6.039-.344.482-.286-.205c-.765-.545-1.354-.82-1.768-.828-.293-.012-.529.108-.708.36a2.32 2.32 0 0 0-.296.634c-.079.258-.25.994-.513 2.208l-2.506 11.478 9.074-5.339c1.092-.65 1.8-1.1 2.125-1.354.325-.253.568-.492.729-.718.185-.26.28-.54.284-.84.003-.298-.093-.596-.287-.892-.269-.414-.711-.84-1.328-1.28l.344-.482 5.797 4.134m5.64 27.295l-.283.52-9.953-5.444.284-.52.632.346c.552.302 1.05.447 1.494.435.315.002.625-.12.93-.367.226-.168.6-.73 1.122-1.684l6.848-12.522c.532-.974.814-1.61.844-1.91.03-.3-.066-.625-.287-.977-.206-.356-.576-.68-1.11-.972l-.631-.345.284-.52 9.953 5.444-.284.519-.632-.346c-.552-.301-1.05-.446-1.495-.434-.315-.002-.63.118-.944.359-.226.168-.6.73-1.122 1.684L297.872 467c-.532.974-.813 1.61-.843 1.91-.02.304.072.635.278.99.221.353.599.675 1.132.966l.632.346m36.36-8.528l-2.566 7.204-.558-.198c.028-2.21-.448-4.067-1.43-5.571-.981-1.505-2.27-2.541-3.868-3.11-1.528-.544-2.953-.565-4.275-.062-1.32.492-2.464 1.432-3.434 2.819a18.891 18.891 0 0 0-2.318 4.507c-.698 1.96-1.08 3.76-1.143 5.402s.293 2.992 1.071 4.05c.788 1.062 1.89 1.846 3.307 2.35a8.304 8.304 0 0 0 1.561.386c.562.076 1.15.11 1.764.102l1.514-4.25c.287-.804.416-1.341.387-1.612-.024-.28-.178-.579-.462-.895-.274-.313-.657-.557-1.15-.732l-.527-.188.199-.557 9.933 3.537-.199.558c-.771-.218-1.337-.3-1.695-.247-.345.047-.663.223-.952.527-.159.159-.37.61-.635 1.353l-1.514 4.25c-1.514.118-3.031.07-4.552-.143-1.514-.2-3.03-.57-4.547-1.11-1.94-.69-3.459-1.526-4.559-2.507a13.216 13.216 0 0 1-2.65-3.288c-.667-1.211-1.086-2.453-1.255-3.725-.21-1.637-.008-3.315.604-5.033 1.095-3.075 3.1-5.288 6.016-6.638 2.915-1.351 6.01-1.443 9.287-.276 1.015.361 1.9.767 2.657 1.218.413.238 1.045.723 1.893 1.456.863.726 1.384 1.121 1.565 1.186.281.1.578.092.891-.023.316-.125.677-.438 1.082-.94l.558.2m15.318 24.586l-.089.586-11.216-1.7.089-.585.712.108c.622.095 1.14.06 1.553-.104.296-.106.546-.328.748-.664.154-.235.313-.89.476-1.967l2.137-14.11c.166-1.097.212-1.792.138-2.084-.075-.291-.276-.565-.604-.82-.316-.263-.775-.44-1.376-.531l-.712-.108.089-.585 11.216 1.699-.089.585-.712-.108c-.622-.094-1.14-.06-1.553.105-.297.106-.551.326-.764.66-.154.236-.313.892-.476 1.968l-2.137 14.11c-.166 1.097-.212 1.792-.138 2.083.085.294.286.572.602.836.328.255.793.428 1.394.519l.712.107m29.114-7.072l-.427 7.648-19.24.982-.03-.592.72-.036c.628-.032 1.129-.17 1.5-.413.27-.164.47-.43.6-.8.105-.262.13-.936.074-2.022l-.728-14.253c-.056-1.108-.15-1.797-.281-2.068-.132-.271-.384-.499-.756-.683-.363-.195-.847-.277-1.455-.246l-.719.037-.03-.592 11.553-.59.03.592-.942.048c-.629.032-1.13.17-1.501.413-.27.164-.475.43-.616.8-.104.262-.129.936-.073 2.023l.704 13.806c.057 1.108.157 1.813.3 2.116.143.291.405.502.786.632.27.083.918.098 1.94.046l1.806-.093c1.15-.058 2.099-.31 2.845-.754.747-.444 1.374-1.116 1.884-2.018.52-.903.987-2.219 1.4-3.949l.656-.033m21.045-3.651l-7.344 2.193-.269 2.285c-.085.76-.061 1.36.07 1.8.174.582.537.941 1.09 1.076.325.082 1.04.001 2.149-.24l.17.567-6.915 2.065-.17-.567c.713-.336 1.235-.825 1.566-1.47.327-.654.607-1.879.839-3.674l2.48-18.809.291-.087 12.59 14.808c1.197 1.401 2.089 2.243 2.674 2.524.442.214.987.25 1.636.113l.17.567-10.057 3.004-.17-.567.414-.124c.808-.24 1.341-.523 1.601-.845.176-.23.218-.5.127-.806a1.962 1.962 0 0 0-.262-.54c-.048-.086-.315-.423-.803-1.012l-1.878-2.261m-.86-.98l-5.236-6.233-1.05 8.112 6.286-1.878m27.726-28.253l2.78 5.172-.507.273c-.942-1.032-1.735-1.708-2.38-2.027-.649-.33-1.376-.477-2.181-.444-.448.023-1.119.274-2.011.754l-1.423.765 7.925 14.741c.525.977.905 1.56 1.14 1.75.244.183.571.285.982.306.416.007.896-.136 1.44-.429l.635-.34.28.52-10.006 5.38-.28-.521.634-.341c.554-.298.948-.637 1.18-1.016.173-.263.245-.592.214-.987-.018-.281-.284-.9-.8-1.86l-7.925-14.74-1.38.742c-1.288.692-2.076 1.467-2.366 2.325-.408 1.2-.341 2.564.2 4.09l-.535.287-2.78-5.172 17.163-9.228m13.014-7.716l5.319 7.05.345-.26c1.098-.828 1.634-1.773 1.608-2.836s-.479-2.317-1.358-3.766l.486-.366 6.84 9.07-.485.366c-.847-.911-1.674-1.556-2.482-1.936-.799-.386-1.496-.522-2.09-.407-.602.106-1.316.47-2.142 1.094l3.681 4.88c.72.953 1.198 1.508 1.435 1.663.246.148.53.207.855.176.324-.03.733-.232 1.227-.605l1.035-.78c1.618-1.22 2.63-2.571 3.035-4.053.414-1.488.256-3.16-.475-5.013l.473-.357 3.374 6.093-14.971 11.292-.357-.472.575-.434c.502-.379.84-.773 1.011-1.183.132-.287.148-.62.049-.999-.06-.275-.419-.847-1.074-1.715l-8.595-11.394c-.59-.784-.975-1.249-1.152-1.396a1.531 1.531 0 0 0-.993-.333c-.503.006-1.036.22-1.598.645l-.575.433-.357-.473 14.498-10.936 3.864 5.123-.485.366c-1.191-1.066-2.218-1.7-3.08-1.905-.855-.211-1.787-.136-2.797.225-.592.206-1.544.804-2.856 1.794l-1.788 1.348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.4 445.547c70.909 57.515 140.41 58.57 208.41 0",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVg);
export default __webpack_public_path__ + "static/media/vg.bdf80cd419704aa592018a517b642f86.svg";
export { ForwardRef as ReactComponent };